import React from 'react';
import { StaticPageLayout } from './StaticPageLayout';
import { PrivacyContent } from './PrivacyContent';

/**
 * `/privacy` — политика конфиденциальности.
 *
 * Обязательное поле Privacy Policy URL в App Store Connect и требование
 * Guideline 5.1.1(i). Адрес зашит в метаданные стора и в меню приложения —
 * менять его нельзя.
 */
export const PrivacyPage: React.FC = () => (
  <StaticPageLayout
    kicker="Правовая информация"
    title="Политика конфиденциальности"
    documentTitle="QPrice — Политика конфиденциальности"
    updatedAt="25 августа 2026 года"
  >
    <div className="qp-prose">
      <PrivacyContent />
    </div>
  </StaticPageLayout>
);
